<template>
  <div>
    <b-row>
      <b-col cols="12">
        <slot name="top-buttons"></slot>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <section v-if="noBody">
          <slot name="filtering">
          </slot>
          <slot name="body">
          </slot>
        </section>
        <b-card v-else>
          <slot name="filtering">
          </slot>
          <slot name="body">
          </slot>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'BaseListWrapper',
  props: {
    noBody: {
      type: Boolean,
      default: false
    }
  }
}
</script>
